import moment from 'moment-timezone'

export default {
  methods: {
    formatLogDate(dateTime) {
      let displayDate
      if (dateTime) { displayDate = moment(dateTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YY hh:mm a') }
      return displayDate || ''
    },
  },
}